'use client';
/**
 * ./src/modules/product/components/shopByInspirationGallery/index.tsx
 *
 * ShopByInspirationGallery component to display the inspiration gallery
 *
 * @copyright DesignShop, 2024
 * @since 09/10/2024
 */
import React from 'react';

import { Carousel, CarouselContent, CarouselItem } from '@/modules/common/components/carousel';
import { SamplesHeading } from '@/modules/product/components/samples/SamplesHeading';
import { SamplesInspirationCard } from '@/modules/product/components/samples/SamplesInspirationCard';
import { sampleInspiration } from '@/modules/product/services/shopSamples';

export const ShopByInspirationGallery = () => {
  return (
    <>
      <SamplesHeading data-testid="shop-the-inspiration-gallery-heading">
        Shop the Inspiration Gallery
      </SamplesHeading>
      <div className="lg:hidden" data-testid="carousel-container">
        <Carousel
          opts={{
            loop: true,
            dragFree: true,
            align: 'start',
          }}
          className="carousel-container-bleed overflow-hidden"
        >
          <CarouselContent className="-ml-2.5" wrapperClassName="max-lg:overflow-visible">
            {sampleInspiration.map((department, index) => (
              <CarouselItem
                key={index}
                className="basis-auto pl-2.5"
                data-testid={`carousel-item-${index}`}
              >
                <SamplesInspirationCard
                  {...department}
                  className="w-full"
                  data-testid={`department-card-mobile-${index}`}
                />
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </div>

      <div className="hidden grid-cols-4 gap-4 lg:grid" data-testid="grid-container">
        {sampleInspiration.map((department, index) => (
          <div key={index} data-testid={`department-${index}`}>
            <SamplesInspirationCard
              {...department}
              desktopHeight={332}
              data-testid={`department-card-desktop-${index}`}
            />
          </div>
        ))}
      </div>
    </>
  );
};
